// chatService.js - Service de gestion des conversations médicales
import { auth } from '../firebase';
import { saveMessage } from './messageService';

export async function sendMessage(message, history = [], conversationId = null, userId = null) {
  const uid = userId || auth.currentUser?.uid;

  if (!uid) {
    throw new Error('Non authentifié');
  }

  try {
    // 1️⃣ Sauvegarder message user (fire-and-forget — pas besoin d'attendre)
    saveMessage(conversationId, message, 'user');

    // 2️⃣ Appel OpenAI
    const token = await auth.currentUser.getIdToken();
    const response = await fetch('https://api-5zm2gcbnlq-ew.a.run.app', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({
        message,
        history,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();

      if (response.status === 429 && errorData.error === 'quota_exceeded') {
        throw new Error('QUOTA_EXCEEDED');
      }

      throw new Error(errorData.error || 'Erreur serveur');
    }

    const aiResponse = await response.json();

    // 3️⃣ Sauvegarder réponse IA
    const aiContent = aiResponse.content || aiResponse.response || aiResponse.message;

    if (!aiContent) {
      console.error('❌ Impossible de trouver le contenu IA dans:', aiResponse);
      throw new Error('Structure réponse IA invalide');
    }

    await saveMessage(conversationId, aiContent, 'assistant');

    return aiResponse;
  } catch (error) {
    console.error('Erreur sendMessage:', error);
    throw error;
  }
}
